import type { Region, RegionProfile } from './types';

export const REGION_PROFILES: Record<Region, RegionProfile> = {
  cn: {
    region: 'cn',
    i18nMode: 'single',
    defaultLocale: 'zh-CN',
    supportedLocales: ['zh-CN'],
    domain: 'biaogeliu.com',
    loadingSite: 'website',
    featureFlags: {},
  },
  global: {
    region: 'global',
    i18nMode: 'multi',
    defaultLocale: 'en-US',
    supportedLocales: ['en-US', 'zh-CN', 'ja-JP'],
    domain: 'sheetflowing.com',
    loadingSite: 'outsourcing-tanstack',
    featureFlags: {},
  },
};
